<template>
  <div>
    <p :class="$style.error" v-if="error"><IconAlert />{{ error }}</p>
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import IconAlert from '@/components/icons/IconAlert.vue'

withDefaults(
  defineProps<{
    error?: string
  }>(),
  {
    error: undefined,
  }
)
</script>

<style lang="scss" module>
.error {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px;
  color: $color-caution-accent;
}
</style>
